import { render, staticRenderFns } from "./BookmarkerPlugin.vue?vue&type=template&id=0a252f62&scoped=true"
import script from "./BookmarkerPlugin.vue?vue&type=script&lang=ts"
export * from "./BookmarkerPlugin.vue?vue&type=script&lang=ts"
import style0 from "./BookmarkerPlugin.vue?vue&type=style&index=0&id=0a252f62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a252f62",
  null
  
)

export default component.exports